// --- External Libraries
import moment from 'moment';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';
import { LinkCellRenderer } from 'datastage/components/AGGrid/cell-renderers/link';

export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'dateMathCalculations',
    }
};

export const sourceRightslineId = {
    field: 'sourceRightslineId',
    headerName: 'Source Rightsline ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'sourceRightslineId',
        page: 'dateMathCalculations',
    }
};

export const catalogId = {
    field: 'catalogId',
    headerName: 'Catalog',
    cellRenderer: LinkCellRenderer(),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'catalogId',
        page: 'dateMathCalculations',
    }
};

export const status = {
    field: 'loadStatus',
    headerName: 'Status',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'loadStatus',
        page: 'dateMathCalculations',
    }
};

export const message = {
    field: 'loadErrorMsg',
    headerName: 'Message',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'loadErrorMsg',
        page: 'dateMathCalculations',
    }
};

export const description = {
    field: 'description',
    headerName: 'Description',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'description',
        page: 'dateMathCalculations',
    }
};

export const type = {
    field: 'dateMathCreateType',
    headerName: 'Type',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'dateMathCalculations',
    }
};

export const dateMathTypeTerms = {
    field: 'dateMathTypeTerms',
    headerName: 'Term Date Type(s)',
    cellRenderer: (params) => {
        return params?.value ? params.value.replace(/,/g, '\n') : '';
    },
};

export const termStart = {
    field: 'beforeOrAfter',
    headerName: 'Term Start',
};

export const termEnd = {
    field: 'endBeforeOrAfter',
    headerName: 'Term End',
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'dateMathCalculations',
    }
};

export const action = (
    onOpenDetailsDrawer,
    onOpenAssociateDrawer,
    onOpenDateMathCalculations,
    onDeleteDateMathCalculation,
) => ({
    headerName: '',
    valueGetter: () => 'DELETE',
    cellRenderer: (params) => {
        const record = params.data;
        const disabled = (
            (record.dateMathCreateType !== "UPDATE" && record.dateMathCreateType !== "UPDATE_ADV" &&
                record.sourceRightslineId !== null && record.sourceRightslineId !== "") ||
            (record.dateMathCreateType === "UPDATE" && record.loadStatus === 'COMPLETE')
        );
        if (disabled) return null;
        return ClickableCellRenderer(onDeleteDateMathCalculation, 'fa-trash')(params);
    },
});
